import apiClient from "./client";

// Get all teams
export function getTeams() {
  return apiClient.get("/teams").then((res) => res.data);
}

// Create a new team
export function createTeam(data) {
  return apiClient.post("/teams", data).then((res) => res.data);
}

// Delete a team by ID
export function deleteTeam(teamId) {
  return apiClient.delete(`/teams/${encodeURIComponent(teamId)}`).then((res) => res.data);
}

// Get users in a specific team
export function getUsersInTeam(teamId) {
  return apiClient.get(`/teams/${encodeURIComponent(teamId)}/users`).then((res) => res.data);
}

// Get users in a specific team
export function getUsers() {
  return apiClient.get(`/teams/users`).then((res) => res.data);
}

export function createUser(payload) {
  return apiClient.post("/teams/users", payload).then((res) => res.data);
}

export function setUserRole(userId, role) {
  return apiClient.post(`/teams/users/${userId}/role`, { role }).then((res) => res.data);
}

// Delete a user
export function deleteUser(userId) {
  return apiClient.delete(`/teams/users/${encodeURIComponent(userId)}`).then((res) => res.data);
}

// Add a user to a team
export function addUserToTeam(teamId, userId) {
  return apiClient
    .post(`/teams/${encodeURIComponent(teamId)}/users`, { userId })
    .then((res) => res.data);
}

// Remove a user from a team
export function removeUserFromTeam(teamId, userId) {
  return apiClient
    .delete(`/teams/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}`)
    .then((res) => res.data);
}

// Get all available roles
export function getRoles() {
  return apiClient.get("/teams/roles").then((res) => res.data);
}

// Set login allowed flag for a user
export function setLoginAllowed(userId, loginAllowed) {
  return apiClient.post(`/teams/users/${userId}/login-allowed`, { loginAllowed }).then((res) => res.data);
}

// Update user details (email, password, role, loginAllowed)
export function updateUser(userId, payload) {
  return apiClient.put(`/teams/users/${userId}`, payload).then((res) => res.data);
}
